angular.module('gym.components').directive('signedWaiverRelease', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '=',
      collapsible: '=',
      defaultCollapsed: '='
    },
    template: require('templates/components/waivers/signed_waiver_release.html.slim')
  };
});
